import { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { inject } from 'mobx-react';
import { confirmAlert } from 'react-confirm-alert';

//components
import withLocalization from '~/hoc/withLocalization';
import withRemoveDialog from '~/hoc/withRemoveDialog';
import applicationRouter from '~/hoc/applicationRouter';
import Button from '../../components/CustomButton/CustomButton.jsx';
import LoadingSpinner from '../../elements/LoadingSpinner.js';

//assets
import CloseModalIcon from '../../assets/img/CloseApproveModalIcon.svg';

//config
import { SAMPLE_FILES_ROOT } from '~/library/config';

//utils
import getBase64 from '~/utils/getBase64';
import { importSVG } from '~/utils/constants.js';
import { translateLabels } from '~/utils/commonMethods.js';
import Select from '../../elements/Select.js';

let absenceTypes = []

class ImportFromExcelModal extends Component {
    constructor(props) {
        super(props);

        const IA_Enabled = props.commonStore.config.client.data.basicRules.IASickLeavesEnabled

        absenceTypes = [
            {
                label: IA_Enabled ? 'Used IA Sick Leaves' : 'Used Sick Leaves',
                key: IA_Enabled ? 'Used IA Sick Leaves' : 'Used Sick Leaves',
                value: IA_Enabled ? 'iaSickLeave' : 'sickLeave', sampleFileName: 'used_sick_leave_with_dates_import_sample_file.xlsx'
            },
            { label: 'Used Parental Leaves', key: 'Used Parental Leaves', value: 'usedParentalLeaves', sampleFileName: 'used_parental_leave_import_sample_file.xlsx' },
        ]

        let entityType = props.importEntityType;
        let sampleFileName = props.sampleFileName;

        if (props.importEntityType === 'importUsedAbsence') {
            entityType = absenceTypes[0].value;
            sampleFileName = absenceTypes[0].sampleFileName;
        }

        this.state = {
            showImportModal: false,
            file: null,
            importing: false,
            message: '',
            entityType,
            sampleFileName
        };
    }

    handleCloseImportBalanceModal = () => {
        this.setState({ file: null, showImportModal: false, importing: false, message: '' });
    }

    handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        this.setState({ file: selectedFile });
    };

    handleCheckSameFileExists = async () => {
        const { file, entityType } = this.state;
        const { t, clientStore } = this.props;

        if (!file || !entityType) return;
        const res = await clientStore.checkSameFileExists({ fileName: file.name, entityType: entityType })
        if (res?.exists) {
            confirmAlert({
                title: t('Are You Sure'),
                message: t('File with same name already uploaded today, do you want to continue?'),
                buttons: [
                    {
                        label: t('Yes'),
                        onClick: () => {
                            this.handleUpload()
                        },
                    },
                    {
                        label: t('No'),
                        onClick: () => { },
                    },
                ],
            })
        } else {
            this.handleUpload()
        }
    }

    handleUpload = async () => {
        try {
            const { file, entityType } = this.state;
            const { t, clientStore, commonStore } = this.props;

            const base64 = await getBase64(file);
            if (!file || !base64 || !entityType) return;

            this.setState({ importing: true })
            const res = await clientStore.importFromExcel({ fileName: file.name, fileBase64: base64, entityType: entityType })
            if (res?.isImportCompleted) {
                this.setState({ file: null, importing: false, message: res?.message });
                commonStore.addNotification(t(res.message), null, 'success');
            }

        } catch (error) {
            this.setState({ file: null, importing: false, message: '' });
            console.error({ error })
        }
    };

    render() {
        const { t, commonStore, entityName } = this.props;
        const { showImportModal, importing, message, sampleFileName } = this.state;

        translateLabels(absenceTypes, t, 'label');

        return (
            <div>
                <Button fill dynamic_lg
                    onClick={() => this.setState({ showImportModal: true })}
                >
                    {importSVG({ width: 24, fillColor: '#ffffff' })}
                    {`${t("Import")}`}
                </Button>
                <Modal size="lg"
                    show={showImportModal}
                    centered
                >
                    <Modal.Header>
                        <Modal.Title className="w-100 text-center ApproveModal__title m-0">
                            {(`${t("Import")}`)} {entityName}
                        </Modal.Title>
                        <img
                            src={CloseModalIcon}
                            className="cursor-pointer"
                            alt='close icon'
                            onClick={() => this.handleCloseImportBalanceModal()}
                        />
                    </Modal.Header>
                    <Modal.Body className='my-0' style={{ height: '200px' }}>
                        {importing ?
                            <div className="d-flex justify-content-center align-items-center h-100">
                                <div className="fw-bold fs-5"><LoadingSpinner /></div>
                            </div>
                            :
                            (message) ?
                                <div className="d-flex justify-content-center align-items-center h-100">
                                    <div className='fw-bold fs-5'>{t(message)}</div>
                                </div>
                                :
                                <div>
                                    <div className="mb-3 d-flex justify-content-between align-items-center">
                                        <span className='fw-600'>{t("Upload")} {t("Excel File")}</span>
                                        {this.props.importEntityType === 'importUsedAbsence' &&
                                            <div className="d-flex justify-content-center align-items-center gap-1">
                                                <span className='fw-600'>{t('Import')}:</span>
                                                <Select
                                                    options={absenceTypes}
                                                    value={absenceTypes.find(item => this.state.entityType === item.value)}
                                                    onChange={(e) => {
                                                        this.setState({ entityType: e.value, sampleFileName: e.sampleFileName })
                                                    }}
                                                    style={{ width: '200px' }}
                                                />
                                            </div>
                                        }
                                        {sampleFileName && <Button
                                            fill
                                            dynamic_lg
                                            onClick={() => {
                                                const link = document.createElement('a');
                                                link.href = `${SAMPLE_FILES_ROOT}/${sampleFileName}`;
                                                link.download = `${sampleFileName}`;
                                                document.body.appendChild(link);
                                                link.click();
                                                document.body.removeChild(link);
                                            }}
                                        >
                                            {t("Download")} {t("Sample File")}
                                        </Button>}
                                    </div>
                                    <div
                                        className={'attachment-box'}
                                        onDragEnter={(e) => { e.preventDefault(); e.stopPropagation(); }}
                                        onDragOver={(e) => { e.preventDefault(); e.stopPropagation(); }}
                                        onDragLeave={(e) => { e.preventDefault(); e.stopPropagation(); }}
                                        onDrop={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            const files = e.dataTransfer.files;
                                            if (files.length > 0) {
                                                const file = files[0];
                                                if (file.name.endsWith('.xlsx')) {
                                                    this.setState({ file });
                                                } else {
                                                    commonStore.addNotification(t('Only Excel (.xlsx) files are allowed'), null, 'error');
                                                }
                                            }
                                        }}
                                        onClick={() => this.fileInputRef.click()}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <input
                                            ref={(ref) => (this.fileInputRef = ref)}
                                            type="file"
                                            style={{ display: 'none' }}
                                            accept=".xlsx"
                                            onChange={this.handleFileChange}
                                        />

                                        {!this.state.file ? (
                                            <p className="m-0 text-muted">
                                                {t('Drag and drop Excel file here, or click to upload')}
                                            </p>
                                        ) : (
                                            <p className="m-0 fw-bold">
                                                {t('Selected file')}: {this.state.file.name}
                                            </p>
                                        )}
                                    </div>
                                </div>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button fill dynamic_lg me2
                            disabled={importing}
                            onClick={this.handleCheckSameFileExists}
                        >
                            {t("Upload")}
                        </Button>
                        <Button variant="secondary"
                            onClick={() => this.handleCloseImportBalanceModal()}
                        >
                            {t("Close")}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default inject('commonStore', 'clientStore')(applicationRouter(withLocalization(withRemoveDialog(ImportFromExcelModal))));